import React, { ReactElement } from "react";
import MainBanner from "@components/camplejeuneapplication/mainBanner";
import CampLejeuneApplicationWrapper from "@components/layouts/campLejeuneApplicationWrapper";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";

import { useDomainContext } from "@hooks/useDomainContext";

const OffersList = dynamic(() => import("@components/shared/offersList"));
const Case = dynamic(() => import("@components/camplejeuneapplication/case"));
const WhyUs = dynamic(() => import("@components/camplejeuneapplication/whyUs"));
const ToxicWaste = dynamic(
    () => import("@components/camplejeuneapplication/toxicWaste"),
);
import GetSupport from "@components/camplejeuneapplication/getSupport";
export default function CampLejeuneApplicationHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <CampLejeuneApplicationWrapper>
            <MainBanner />

            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Case />
            <WhyUs />
            <ToxicWaste />
            <GetSupport />
        </CampLejeuneApplicationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
